import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { changeSetting } from 'mastodon/actions/settings';
import { Card } from 'mastodon/features/explore/components/card';
import { StatusSkeletonLoading } from './status-skeleton-loading';

const DISMISSIBLE_ID = 'home/follow-suggestions';

const mapStateToProps = state => {
  return {
    suggestions: state.suggestions.items,
    isLoading: state.suggestions.isLoading,
    dismissed: state.settings.getIn(['dismissed_banners', DISMISSIBLE_ID]),
  };
};

const MobileWhoToFollow = ({ suggestions, isLoading, dismissed }) => {
  const dispatch = useDispatch();

  const handleDismiss = useCallback(() => {
    dispatch(changeSetting(['dismissed_banners', DISMISSIBLE_ID], true));
  }, [dispatch]);

  if (dismissed || (!isLoading && (!suggestions || suggestions.length === 0))) {
    return null;
  }

  return (
    <div className='mobile-suggestions'>
      <div className='mobile-suggestions__header'>
        <h3 className='mobile-suggestions__title'>
          <FormattedMessage id='follow_suggestions.who_to_follow' defaultMessage='Who to follow' />
        </h3>

        <div className='mobile-suggestions__header__actions'>
          <button className='link-button' onClick={handleDismiss}>
            <FormattedMessage
              id='follow_suggestions.dismiss'
              defaultMessage="Don't show again"
            />
          </button>
          <Link to='/explore/suggestions' className='link-button'>
            <FormattedMessage
              id='follow_suggestions.view_all'
              defaultMessage='View all'
            />
          </Link>
        </div>
      </div>

      <div className='mobile-suggestions__container'>
        <div className='mobile-suggestions__scroll-area'>
          {isLoading ? (
            <div className='mobile-suggestions__loading'>
              {[...Array(4)].map((_, index) => (
                <div key={index} className='mobile-suggestions__skeleton'>
                  <StatusSkeletonLoading isFollowPage count={1} />
                </div>
              ))}
            </div>
          ) : (
            <div className='mobile-suggestions__list'>
              {suggestions?.slice(0, 20).map((suggestion) => (
                <Card
                  key={suggestion.account_id}
                  id={suggestion.account_id}
                  source={suggestion.sources[0]}
                  className='mobile-suggestions__card'
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(MobileWhoToFollow);
